import { render, staticRenderFns } from "./ResultSummary.vue?vue&type=template&id=b799398c&lang=pug"
import script from "./ResultSummary.vue?vue&type=script&lang=ts"
export * from "./ResultSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports